import { render, staticRenderFns } from "./PendingClip.vue?vue&type=template&id=0f57a76c"
import script from "./PendingClip.vue?vue&type=script&lang=js"
export * from "./PendingClip.vue?vue&type=script&lang=js"
import style0 from "./PendingClip.vue?vue&type=style&index=0&id=0f57a76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
